import { applyMiddleware, combineReducers, legacy_createStore as createStore } from "redux";
import thunk from "redux-thunk";
import { userReducers } from "./reducers/userReducers";

const rootReducers = combineReducers({
    user: userReducers
})

export const store = createStore(rootReducers,{}, applyMiddleware(thunk));